export default 'M15.61 2.83c.52.53.52 1.37 0 1.9l-8.44 8.44c-.53.52-1.37.52-1.9 0L.4 8.27A1.33 1.33 0 1 1 2.28 6.4l3.94 3.95 7.5-7.5a1.33 1.33 0 0 1 1.89 0';